import { api } from './api';

const login = async (data) => {
    const response = await api({
        url: 'Auth/login',
        method: 'POST',
        data,
    });
    return response.data;
};

const loginAdmin = async (data) => {
    const response = await api({
        url: 'Auth/loginadmin',
        method: 'POST',
        data,
    });
    return response.data;
};

const loginOtp = async (data) => {
    const response = await api({
        url: 'Auth/loginOtp',
        method: 'POST',
        data,
    });
    return response.data;
};

const forgotPassword = async (data) => {
    const response = await api({
        url: 'Auth/forgotpassword',
        method: 'PUT',
        data,
    });
    return response.data;
};
const migrationOtp = async (data) => {
    const response = await api({
        url: 'Auth/migrationOtp',
        method: 'POST',
        data,
    });
    return response.data;
};

const forgotPasswordChange = async (data) => {
    const response = await api({
        url: 'Auth/forgottenpasswordchange',
        method: 'PUT',
        data,
    });
    return response.data;
};

const reSendOtpSms = async (data) => {
    const response = await api({
        url: 'Auth/resendotpsms',
        method: 'POST',
        data,
    });
    return response.data;
};

const forgottenPasswordTokenCheck = async (data) => {
    const response = await api({
        url: 'Auth/forgottenPasswordTokenCheck',
        method: 'PUT',
        data,
    });
    return response.data;
};

const changeUserPassword = async (data) => {
    const response = await api({
        url: 'Auth/changeuserpassword',
        method: 'PUT',
        data,
    });
    return response.data;
};

const logout = async () => {
    const response = await api({
        url: 'Auth/logout',
        method: 'GET',
    });
    return response.data;
};

const loginUserWithoutPassword = async (data) => {
    const response = await api({
        url: 'Auth/stealthLogin',
        method: 'POST',
        data,
    });
    return response.data;
};

const refreshToken = async (data) => {
    const response = await api({
        url: 'Auth/refresh-token',
        method: 'POST',
        data,
    });
    return response.data;
};

const forgotPasswordAdmin = async (data) => {
    const response = await api({
        url: 'Auth/admin/forgotpassword',
        method: 'PUT',
        data,
    });
    return response.data;
};

const forgotPasswordChangeAdmin = async (data) => {
    const response = await api({
        url: 'Auth/admin/forgottenpasswordchange',
        method: 'PUT',
        data,
    });
    return response.data;
};

const forgottenPasswordTokenCheckAdmin = async (data) => {
    const response = await api({
        url: 'Auth/admin/forgottenPasswordTokenCheck',
        method: 'PUT',
        data,
    });
    return response.data;
};

const loginOtpDisable = async (data) => {
    const response = await api({
        url: 'Auth/LoginOtpDisable',
        method: 'POST',
        data,
    });
    return response.data;
};

const preLogin = async (data) => {
    const response = await api({
        url: 'Auth/PreLogin',
        method: 'POST',
        data,
    });
    return response.data;
};
const loginOtpExclude = async (data) => {
    const response = await api({
        url: 'Auth/LoginOtpExclude',
        method: 'POST',
        data,
    });
    return response.data;
};

const authServices = {
  login,
  loginAdmin,
  migrationOtp,
  loginOtp,
  reSendOtpSms,
  forgotPassword,
  forgotPasswordChange,
  forgottenPasswordTokenCheck,
  changeUserPassword,
  logout,
  loginUserWithoutPassword,
  forgotPasswordAdmin,
  forgotPasswordChangeAdmin,
  forgottenPasswordTokenCheckAdmin,
  refreshToken,
  loginOtpDisable,
  preLogin,
  loginOtpExclude,
};

export default authServices;
